import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Chart from 'chart.js/auto';
import Itg from './ITG_BLANCO.png'  
import ItgNegro from './ITG-Logo-Negro.png'  
import Scapp from './logo_scapp_blanco.png'  
import ScappNegro from './logo_scapp_negro.png'  


  function normalizeColor(color) {
    if (!color) return [150, 150, 150]; // gris por defecto

    // --- si es un array de colores (Chart.js stacked/gradient)
    if (Array.isArray(color)) {
      return normalizeColor(color[0]);
    }

    // --- si es en formato rgb/rgba
    if (color.startsWith("rgb")) {
      const values = color
        .replace(/^rgba?\(|\s+|\)$/g, "")
        .split(",")
        .map(v => parseFloat(v));
      return values.slice(0, 3); // devuelve [r,g,b]
    }

    // --- si es hex (#rrggbb o #rgb)
    if (color.startsWith("#")) {
      let hex = color.replace("#", "");
      if (hex.length === 3) {
        hex = hex.split("").map(c => c + c).join("");
      }
      const bigint = parseInt(hex, 16);
      return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    }

    return [150, 150, 150]; // fallback gris
  }

  function filterChartDataForPDF(originalData) {
    // Encuentra las posiciones (índices) donde todos los datasets son 0 o null
    const validIndexes = originalData.labels.map((_, i) => {
      return originalData.datasets.some(ds => {
        const v = Array.isArray(ds.data) ? ds.data[i] : undefined;
        return v !== 0 && v !== null && v !== undefined;
      });
    });

    // Filtrar labels y datasets
    return {
      labels: originalData.labels.filter((_, i) => validIndexes[i]),
      datasets: originalData.datasets.map(ds => ({
        ...ds,
        data: ds.data.filter((_, i) => validIndexes[i])
      }))
    };
  }
  
  const itg = Itg
  const itgNegro = ItgNegro
  const scapp = Scapp
  const scappNegro = ScappNegro
  // const logoITGPath = darkModePDF ? itg : itgNegro;
  // const logoSCAPPPath = darkModePDF ? scapp : scappNegro;

  // util para cargar imágenes desde /public en base64
  const loadImageBase64 = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = src;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
    });
  };

export async function exportToPDF (chart, opts = {}  ) {
  const {
    darkModePDF = false,
    title='SFR Corregido [ % ]' ,
    invert,
    horizontalLinePlugin ,            // ← un gráfico por métrica
    fileName = 'Reporte_General.pdf',
    onProgress
  } = opts;
  
  if (!chart) { console.error('exportToPDF: chart null'); return; }

  const MAX_COLUMNS = invert ? 12 : 24;              // límite por tabla (incluye "Etiqueta")
  const PDF_ORIENTATION = 'landscape'; // 'portrait' | 'landscape'
  
  
  try {
    const src = chart;
    if (!src) return;

        // 🔹 Seleccionar logos según darkModePDF
    const logoITGPath = darkModePDF ? itg : itgNegro;
    const logoSCAPPPath = darkModePDF ? scapp : scappNegro;

    // 🔹 Cargar logos primero
    const [logoITG, logoSCAPP] = await Promise.all([
      loadImageBase64(logoITGPath),
      loadImageBase64(logoSCAPPPath),
    ]);

    // 1) Filtrar datos SOLO para el gráfico
    const filteredData = filterChartDataForPDF(src?.config?.data);

    // 2) Canvas temporal
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = src.canvas.width;
    tempCanvas.height = src.canvas.height;
    const tempCtx = tempCanvas.getContext("2d");

    const axisColor = darkModePDF ? "#ffffff" : "#000000";
    const gridColor = darkModePDF ? "#444444" : "rgba(0,0,0,0.3)";

    // 3) Chart temporal
    const tempChart = new Chart(tempCtx, {
      type: "bar",
      data: {
        ...filteredData,
        datasets: filteredData.datasets.map((ds) => ({
          ...ds,
          backgroundColor: ds.backgroundColor.replace(/[\d.]+\)$/g, "1)"), // quitar opacidad
        })),
      },
      options: {
        responsive: false,
        animation: false,
        plugins: { legend: { display: false }, tooltip: { enabled: false } },
        scales: {
          x: {
            title: {
              display: true,
              text: invert ? "Jaulas" : "Fechas",
              color: axisColor,
              font: { size: 12, weight: "bold" },
            },
            ticks: { color: axisColor },
            grid: { color: gridColor },
          },
          y: {
            title: {
              display: true,
              text: "SFR [%]",
              color: axisColor,
              font: { size: 12, weight: "bold" },
            },
            ticks: { color: axisColor },
            grid: { color: gridColor },
          },
        },
      },
      plugins: [horizontalLinePlugin],
    });
    if (onProgress) onProgress(10);
    
    await new Promise((r) => setTimeout(r, 200));
    const imgData = tempCanvas.toDataURL("image/png");

    // 4) Crear PDF
    const pdf = new jsPDF({
      orientation: PDF_ORIENTATION,
      unit: "pt",
      format: "a4",
    });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const pageBackground = darkModePDF ? "#1e1e1e" : "#ffffff";
    const textColor = darkModePDF ? "#ffffff" : "#000000";
    const borderColor = darkModePDF ? "#ffffff" : "#000000";

    // === Header y marca de agua ===
    // === FLAGS ===
    const WATERMARK_FIRST_PAGE = false; 

    const HEADER_HEIGHT = 60;

    const TABLE_TOP = HEADER_HEIGHT + 20; // 👈 espacio seguro para header en TODAS las páginas con tablas


    const paintHeader = () => {
      const itgW = 70;
      const scappW = 120;
      const itgY = (HEADER_HEIGHT - 40) / 2;
      const scappY = (HEADER_HEIGHT - 30) / 2 + 9;

      pdf.addImage(logoITG, "PNG", 40, itgY, itgW, 0);
      pdf.addImage(logoSCAPP, "PNG", pageWidth - scappW - 40, scappY, scappW, 0);
    };

    // Fondo completo SOLO en la primera página (para no tapar tablas en páginas siguientes)
    const paintFullBgFirstPage = () => {
      pdf.setFillColor(pageBackground);
      pdf.rect(0, 0, pageWidth, pageHeight, "F");
      paintHeader();
    };

    // ======= Página inicial (gráfico) =======
    paintFullBgFirstPage();

    pdf.setFontSize(16);
    pdf.setTextColor(textColor);
    pdf.setFont("helvetica", "bold");
    pdf.text("SFR CORREGIDO [ % ]", pageWidth / 2, 75, { align: "center" });

    // === Calcular tamaño del gráfico (más bajo, mismo ancho)
    const imgWidth = pageWidth * 0.8;
    const imgHeight = tempCanvas.height * (imgWidth / tempCanvas.width)  // bajar altura
    const posX = (pageWidth - imgWidth) / 2;

    // === Parámetros compartidos con el contenedor del gráfico
    const PAD = 12; // mismo padding que usas en el contenedor del gráfico

    // === Leyendas con contenedor del MISMO ancho que el contenedor del gráfico
    const dataLeyendas = src.config.data?.datasets || [];
    const boxSize = 12;
    const spacingX = 90;
    const spacingY = 22;
    const maxPerRow = 7;
    const marginBetween = 20;

    let count = dataLeyendas.filter((ds) => ds.label).length;
    let rows = Math.ceil(count / maxPerRow);

    // ⚠️ IMPORTANTE: usamos el MISMO ancho visual que el "marco" del gráfico
    const legendBoxX = posX - PAD;                 // mismo X que el marco del gráfico
    const legendBoxY = 95;
    const containerWidth = imgWidth + PAD * 2;     // mismo ancho que el marco del gráfico
    const containerHeight = rows * spacingY + 18;

    // Dibuja el contenedor de leyendas
    pdf.setFillColor(darkModePDF ? "#2b2b2b" : "#f5f5f5");
    pdf.setDrawColor(darkModePDF ? "#444" : "#cccccc");
    pdf.roundedRect(legendBoxX, legendBoxY, containerWidth, containerHeight, 6, 6, "FD");

    // Área interior útil (excluye padding visual)
    const legendInnerX = legendBoxX + PAD;
    const legendInnerW = containerWidth - PAD * 2;

    // Distribución centrada por fila dentro del ancho interior
    let legendCount = 0;
    dataLeyendas.forEach((ds) => {
      if (!ds.label) return;

      const row = Math.floor(legendCount / maxPerRow);
      const col = legendCount % maxPerRow;

      const totalRowItems = Math.min(count - row * maxPerRow, maxPerRow);
      const rowContentWidth = totalRowItems * spacingX;
      const startX = legendInnerX + (legendInnerW - rowContentWidth) / 2;

      const x = startX + col * spacingX;
      const y = legendBoxY + 20 + row * spacingY;

      const [r, g, b] = normalizeColor(ds.backgroundColor);
      pdf.setFillColor(r, g, b);
      pdf.rect(x, y, boxSize, boxSize, "F");

      pdf.setTextColor(darkModePDF ? "#fff" : "#000");
      pdf.setFontSize(10);
      pdf.text(ds.label, x + boxSize + 6, y + boxSize - 2);

      legendCount++;
    });

    // === Gráfico debajo del contenedor de leyendas
    const posY = legendBoxY + containerHeight + marginBetween;

    // if (!darkModePDF) {
    pdf.setFillColor(darkModePDF ? "#2b2b2b" : "#f5f5f5");
    pdf.setDrawColor(darkModePDF ? "#444444" : "#cccccc");
    pdf.roundedRect(
      posX - PAD,
      posY - PAD,
      imgWidth + PAD * 2,
      imgHeight + PAD * 2,
      6,
      6,
      "FD"
    );

    // }

    pdf.addImage(imgData, "PNG", posX, posY, imgWidth, imgHeight);

    
    if (onProgress) onProgress(40); // gráfico listo
    // ======= Tablas =======
    let labels = src.config.data?.labels || [];
    const datasets = src.config.data?.datasets || [];

    labels = [...labels].sort((a, b) => {
      if (!isNaN(a) && !isNaN(b)) return Number(a) - Number(b);
      return String(a).localeCompare(String(b));
    });

    const CHUNK_DATASET_SIZE = Math.max(1, MAX_COLUMNS - 1);
    const valueAt = (ds, label) => {
      const idx = src.config.data.labels.indexOf(label);
      if (idx === -1) return "";
      const v = Array.isArray(ds.data) ? ds.data[idx] : undefined;
      return v && typeof v === "object" ? v.y : v;
    };

    let currentStartY =
      PDF_ORIENTATION === "portrait" ? posY + imgHeight + 40 : 60;

    // Si la orientación es landscape, pasa tablas a nueva página SIN fondo completo
    if (PDF_ORIENTATION === "landscape") {
      pdf.addPage();
      paintHeader(); // solo logos
      // addWatermark(); // overlay
      currentStartY = TABLE_TOP;
    }

    // Estilos de tabla (modo claro/oscuro sin cubrir página)
    const baseStyles = {
      fontSize: 8,
      halign: "center",
      valign: "middle",
      lineColor: borderColor,
      lineWidth: 0.25,
      textColor: darkModePDF ? "#ffffff" : textColor,
      // fillColor: undefined,//darkModePDF ? "#121212" : undefined, // fondo celda base
    };
    const headStyles = {
      fillColor: "#e84e0e",
      textColor: "#ffffff",
      halign: "center",
      lineColor: borderColor,
      lineWidth: 0.5,
    };
    const altRow = darkModePDF
      ? { /*fillColor: "#1f1f1f", textColor: "#ffffff"*/ }
      : {};

    let tableIndex = 1;
    const totalChunks = Math.ceil(datasets.length / CHUNK_DATASET_SIZE);
    
    for (let start = 0; start < datasets.length; start += CHUNK_DATASET_SIZE) {
      const chunkDatasets = datasets.slice(start, start + CHUNK_DATASET_SIZE);

      const head = [["Etiqueta", ...chunkDatasets.map((ds) => ds.label || "")]];
      const body = labels.map((label) => [
        label,
        ...chunkDatasets.map((ds) => valueAt(ds, label)),
      ]);

      if (tableIndex > 1) {
        pdf.addPage();
        paintHeader(); // solo logos
        // addWatermark(); // overlay
        currentStartY = TABLE_TOP;
      }
      autoTable(pdf, {
        head, body,
        startY: TABLE_TOP,
        theme: "grid",
        styles: baseStyles,
        headStyles,
        alternateRowStyles: altRow,
        margin: { left: 40, right: 40, top: TABLE_TOP, bottom: 40 },

        // Fondo completo + header + watermark en cada página de tablas
        willDrawPage: (data) => {
          if (darkModePDF) {
            pdf.setFillColor(pageBackground);          // "#1e1e1e"
            pdf.rect(0, 0, pageWidth, pageHeight, "F");
          }
          paintHeader();
          // if (data.pageNumber > 1 || WATERMARK_FIRST_PAGE) addWatermark();
        },

        // 🔑 Forzamos body transparente solo en Dark (header se mantiene con su fill)
        didParseCell: (data) => {
          if (darkModePDF && (data.section === "body" || data.section === "foot")) {
            data.cell.styles.fillColor = undefined;    // sin relleno
          }
        },
      });

      // Helper: watermark + numeración para TODAS las páginas
      currentStartY = pdf.lastAutoTable.finalY + 40;

      if (onProgress) {
        const percent = 40 + Math.round(((tableIndex - 1) / totalChunks) * 55);
        onProgress(percent);
      }

      tableIndex++;
    }
    if (onProgress) onProgress(95);
    
    const stampAllPages = (pdf, watermarkImg, darkModePDF, WATERMARK_FIRST_PAGE) => {
      const total = pdf.internal.getNumberOfPages();

      for (let i = 1; i <= total; i++) {
        pdf.setPage(i);

        const w = pdf.internal.pageSize.getWidth();
        const h = pdf.internal.pageSize.getHeight();

        // --- Marca de agua ---
        if (i > 1 || WATERMARK_FIRST_PAGE) {
          const wmW = Math.min(500, w * 0.65);
          const wmX = (w - wmW) / 2;
          const wmY = h / 2 - wmW * 0.38;

          pdf.setGState(new pdf.GState({ opacity: 0.08 }));
          pdf.addImage(watermarkImg, "PNG", wmX, wmY, wmW, 0);
          pdf.setGState(new pdf.GState({ opacity: 1 }));
        }

        // --- Número de página ---
        const label = `${i} / ${total}`;
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(10);
        pdf.setTextColor(darkModePDF ? "#ffffff" : "#000000");

        pdf.text(label, w - 40, h - 24, { align: "right" });
      }
    };


    stampAllPages(pdf, logoITG, darkModePDF, WATERMARK_FIRST_PAGE);

    if (onProgress) onProgress(100); // ✅ terminado
    pdf.save("SFR.pdf");
    tempChart.destroy();
  } catch (err) {
    console.error("Error en exportToPDF:", err);
  }
};

